import { render, staticRenderFns } from "./RequestSearch.vue?vue&type=template&id=d9d470d8&scoped=true&"
import script from "./RequestSearch.vue?vue&type=script&lang=ts&"
export * from "./RequestSearch.vue?vue&type=script&lang=ts&"
import style0 from "./RequestSearch.vue?vue&type=style&index=0&id=d9d470d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d470d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
